/**
 * Sätter öppet/stängt läge på "Rabattkod / Logga in / Skapa konto"-details (#lw-checkout-extras):
 * öppen på desktop (md och uppåt), stängd på mobil. Läget sätts vid sidladdning — användaren kan
 * sedan toggla fritt utan att vi skriver över valet.
 */
function initCheckoutExtras() {
    const details = document.getElementById('lw-checkout-extras')
    if (!details) return

    // md-breakpointen i Tailwind är 768px.
    details.open = window.matchMedia('(min-width: 768px)').matches
}

document.addEventListener('DOMContentLoaded', initCheckoutExtras)
